/* Dvn Cyber Labs — "Signal" theme interactions */
(function () {
  "use strict";

  /* Mobile nav toggle */
  function initNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var nav = document.querySelector("[data-site-nav]");
    if (!toggle || !nav || toggle.dataset.bound) return;
    toggle.dataset.bound = "true";
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("keydown", function(e) { if(e.key === "Escape") { nav.classList.remove("is-open"); toggle.setAttribute("aria-expanded", "false"); } });
    nav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        nav.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  /* Sticky header gains a solid state once scrolled */
  function initHeaderState() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    function update() {
      if (window.scrollY > 12) header.classList.add("is-scrolled");
      else header.classList.remove("is-scrolled");
    }
    update();
    window.addEventListener("scroll", update, { passive: true });
  }

  /* Accordions (FAQ + product FAQ) */
  /* Product gallery thumbnail switching */
  function initGallery() {
    var gallery = document.querySelector("[data-gallery]");
    if (!gallery || gallery.dataset.bound) return;
    gallery.dataset.bound = "true";
    // Fall back to the first image inside the main frame if the data hook
    // wasn't emitted by image_tag.
    var mainImg =
      gallery.querySelector("[data-gallery-main]") ||
      gallery.querySelector(".gallery__main img");
    var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    if (!mainImg || !thumbs.length) return;

    function setMain(src, alt, srcset, sizes) {
      if (!src) return;
      if (srcset) {
        mainImg.setAttribute("sizes", sizes || "100vw");
        mainImg.setAttribute("srcset", srcset);
      } else {
        mainImg.removeAttribute("srcset");
        mainImg.removeAttribute("sizes");
      }
      mainImg.setAttribute("src", src);
      if (alt != null) mainImg.setAttribute("alt", alt);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        setMain(thumb.getAttribute("data-full"), thumb.getAttribute("data-alt") || "", thumb.getAttribute("data-srcset"), thumb.getAttribute("data-sizes"));
        thumbs.forEach(function (t) {
          t.classList.remove("is-active");
          t.setAttribute("aria-current", "false");
        });
        thumb.classList.add("is-active");
        thumb.setAttribute("aria-current", "true");
      });
    });
  }

  /* Variant selector updates displayed price, stock counter, hidden id */
  function updateStock(managed, inventory) {
    var el = document.querySelector("[data-stock-counter]");
    if (!el) return;
    var qty = parseInt(inventory, 10);
    if (managed && managed !== "" && !isNaN(qty) && qty > 0 && qty <= 10) {
      el.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg> Only <strong>' +
        qty +
        "</strong> left in stock";
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function initVariants() {
    var selects = document.querySelectorAll("[data-variant-select]");
    selects.forEach(function (select) {
      if (select.dataset.bound) return;
      select.dataset.bound = "true";
      select.addEventListener("change", function () {
        var opt = select.options[select.selectedIndex];
        var form = select.closest("form");
        var idInput = form ? form.querySelector("[data-variant-id]") : null;
        if (idInput) idInput.value = select.value;
        var price = opt.getAttribute("data-price");
        var priceEl = document.querySelector("[data-current-price]");
        if (price && priceEl) priceEl.textContent = price;
        var available = opt.dataset.available === "true";
        var submit = form.querySelector('[name="add"]');
        if (submit) { submit.disabled = !available; submit.textContent = available ? window.themeStrings.add : window.themeStrings.sold; }
        var url = new URL(window.location.href); url.searchParams.set("variant", select.value); window.history.replaceState({}, "", url);
        updateStock(opt.getAttribute("data-inv-managed"), opt.getAttribute("data-inventory"));
      });
    });
  }

  /* ---------- Slide-out cart ---------- */
  var ROOT =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function cartEndpoint(path) {
    return ROOT.replace(/\/$/, "") + path;
  }

  var cartOpener = null;

  function cartPanel() {
    return document.querySelector(".cart-drawer__panel");
  }

  function focusable(container) {
    if (!container) return [];
    return Array.prototype.filter.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ),
      function (el) {
        return el.offsetParent !== null;
      }
    );
  }

  function openCart() {
    if (document.body.classList.contains("cart-open")) return;
    cartOpener = document.activeElement;
    document.body.classList.add("cart-open");
    document.querySelectorAll(".site-header, #MainContent, .site-footer").forEach(function(el){el.inert=true;});
    var panel = cartPanel();
    var first = focusable(panel)[0];
    if (first) {
      window.requestAnimationFrame(function () {
        first.focus();
      });
    }
  }

  function closeCart() {
    if (!document.body.classList.contains("cart-open")) return;
    document.body.classList.remove("cart-open");
    document.querySelectorAll(".site-header, #MainContent, .site-footer").forEach(function(el){el.inert=false;});
    if (cartOpener && typeof cartOpener.focus === "function") cartOpener.focus();
    cartOpener = null;
  }

  function trapCartFocus(e) {
    if (e.key !== "Tab" || !document.body.classList.contains("cart-open")) return;
    var items = focusable(cartPanel());
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* Lightweight transient toast for cart errors */
  function showToast(message) {
    var el = document.createElement("div");
    el.className = "toast";
    el.setAttribute("role", "status");
    el.textContent = message;
    document.body.appendChild(el);
    window.requestAnimationFrame(function () {
      el.classList.add("is-visible");
    });
    setTimeout(function () {
      el.classList.remove("is-visible");
      setTimeout(function () {
        el.remove();
      }, 300);
    }, 4000);
  }

  function syncCartCount() {
    var drawer = document.querySelector("[data-cart-drawer]");
    var badge = document.querySelector("[data-cart-count]");
    if (!drawer || !badge) return;
    var count = parseInt(drawer.getAttribute("data-item-count"), 10) || 0;
    badge.textContent = count;
    badge.hidden = count === 0;
  }

  function refreshCart(shouldOpen) {
    return fetch(ROOT + "?sections=cart-drawer", {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var html = data["cart-drawer"];
        if (typeof html !== "string") throw new Error(window.themeStrings.cartError);
        var current = document.getElementById("shopify-section-cart-drawer");
        if (!current) throw new Error(window.themeStrings.cartError);
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fetched = doc.getElementById("shopify-section-cart-drawer");
        var oldFocus = document.activeElement;
        var focusedLine = oldFocus && oldFocus.closest("[data-cart-line]");
        var focusKey = focusedLine && focusedLine.dataset.lineKey;
        var focusAction = oldFocus && ["data-cart-plus", "data-cart-minus", "data-cart-remove"].find(function(a){ return oldFocus.hasAttribute(a); });
        current.innerHTML = fetched ? fetched.innerHTML : html;
        if (document.body.classList.contains("cart-open")) {
          var target = Array.from(current.querySelectorAll("[data-cart-line]")).find(function(line){ return line.dataset.lineKey === focusKey; });
          target = target && focusAction ? target.querySelector("[" + focusAction + "]") : current.querySelector("[data-cart-close][type=button]");
          if(target)target.focus();
        }
        syncCartCount();
        if (shouldOpen) openCart();
      })
      .catch(function () { window.location.assign(cartEndpoint("/cart")); });
  }

  var cartBusy = false;

  function changeLine(key, qty, line) {
    if (cartBusy) return;
    cartBusy = true;
    if (line) line.classList.add("is-busy");
    return fetch(cartEndpoint("/cart/change.js"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok)
          return r.json().then(function (j) {
            throw j;
          });
        return r.json();
      })
      .then(function () {
        return refreshCart(false);
      })
      .catch(function (err) {
        showToast((err && err.message) || "Couldn't update your cart. Please try again.");
      })
      .then(function () {
        cartBusy = false;
        if(line) line.classList.remove("is-busy");
      });
  }

  function initCart() {
    // Intercept all add-to-cart forms (product page + product cards).
    document.addEventListener("submit", function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      if (form.dataset.submitting) return;
      form.dataset.submitting = "true";
      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.classList.add("is-loading");
        btn.disabled = true;
      }
      fetch(cartEndpoint("/cart/add.js"), {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok)
            return r.json().then(function (j) {
              throw j;
            });
          return r.json();
        })
        .then(function (added) {
          if(window.dvnTrack)window.dvnTrack("add_to_cart_confirmed",{variant_id:String(added.variant_id||added.id),quantity:added.quantity});
          return refreshCart(true);
        })
        .catch(function (err) {
          showToast(
            (err && (err.description || err.message)) ||
              "Couldn't add this item. Please try again."
          );
        })
        .then(function () {
          delete form.dataset.submitting;
          if (btn) {
            btn.classList.remove("is-loading");
            btn.disabled = false;
          }
        });
    });

    // Open / close + line item controls (delegated, survives re-render).
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-toggle]")) {
        e.preventDefault();
        openCart();
        return;
      }
      if (e.target.closest("[data-cart-close]")) {
        closeCart();
        return;
      }
      var line = e.target.closest("[data-cart-line]");
      if (!line) return;
      var key = line.getAttribute("data-line-key");
      var qtyEl = line.querySelector("[data-cart-qty]");
      var qty = parseInt(qtyEl ? qtyEl.textContent : "1", 10) || 1;
      if (e.target.closest("[data-cart-plus]")) changeLine(key, qty + 1, line);
      else if (e.target.closest("[data-cart-minus]")) changeLine(key, Math.max(0, qty - 1), line);
      else if (e.target.closest("[data-cart-remove]")) changeLine(key, 0, line);
    });

    // Trap focus inside the drawer while it is open.
    document.addEventListener("keydown", trapCartFocus);
  }

  /* ---------- Image zoom lightbox ---------- */
  function initZoom() {
    var frame = document.querySelector(".gallery__main");
    if (!frame || frame.dataset.zoomBound) return;
    frame.dataset.zoomBound = "true";
    frame.addEventListener("click", function(e) {
      if (!e.target.closest("[data-zoom-trigger]") && e.target.tagName !== "IMG") return;
      var source = frame.querySelector("img"); if (!source) return;
      var opener = document.activeElement;
      var dialog = document.createElement("dialog"); dialog.className = "lightbox";
      dialog.setAttribute("aria-label", window.themeStrings.zoom);
      var close = document.createElement("button"); close.type = "button"; close.className = "lightbox__close"; close.textContent = "×"; close.setAttribute("aria-label", window.themeStrings.close);
      var img = document.createElement("img"); img.src = source.currentSrc || source.src; img.alt = source.alt;
      dialog.append(close, img); document.body.append(dialog);
      close.addEventListener("click", function(){dialog.close();});
      dialog.addEventListener("click", function(e){if(e.target === dialog)dialog.close();});
      dialog.addEventListener("close", function(){dialog.remove();if(opener)opener.focus();});
      dialog.showModal();
    });
  }

  /* ---------- Back-to-top ---------- */
  function initBackToTop() {
    var btn = document.querySelector("[data-back-to-top]");
    if (!btn) return;
    function update() {
      if (window.scrollY > 600) btn.classList.add("is-visible");
      else btn.classList.remove("is-visible");
    }
    update();
    window.addEventListener("scroll", update, { passive: true });
    btn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  /* Close cart drawer on Escape */
  function initEscClose() {
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeCart();
    });
  }

  /* ---------- Related / recommended products ---------- */
  function initRecommendations() {
    var holder = document.querySelector("[data-product-recommendations]");
    if (!holder) return;
    var url = holder.getAttribute("data-url");
    if (!url) return;
    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, "text/html");
        var fresh = doc.querySelector("[data-product-recommendations]");
        if (fresh && fresh.innerHTML.trim().length) {
          holder.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {});
  }

  /* Scroll-triggered reveal on key blocks (no-JS users still see content) */
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  document.addEventListener("shopify:section:load", function(){ initNav(); initGallery(); initVariants(); initZoom(); initRecommendations(); });

  ready(function () {
    initNav();
    initHeaderState();

    initGallery();
    initVariants();

    initCart();
    initZoom();
    initBackToTop();
    initEscClose();
    initRecommendations();
  });
})();
